import { render, staticRenderFns } from "./BusinessTaxReturnModal.vue?vue&type=template&id=a60e3d60&scoped=true&"
import script from "./BusinessTaxReturnModal.vue?vue&type=script&lang=ts&"
export * from "./BusinessTaxReturnModal.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTaxReturnModal.vue?vue&type=style&index=0&id=a60e3d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e3d60",
  null
  
)

export default component.exports